import { createRouter, createWebHistory } from 'vue-router'
import * as CryptoJS from 'crypto-js';


///client file views
import Dashbord from "../views/Dashbord.vue"
import AddParcel from '../views/AddParcel.vue';
import IncomingParcels from '@/views/IncomingParcels.vue';
import OutgoingParcel from '@/views/OutgoingParcel.vue';
import TransitParcels from '@/views/TransitParcels.vue';
import ReceivedParcel from '@/views/ReceivedParcel.vue';
import DeletedParcels from '@/views/DeletedParcels.vue';
import BMReceivedParcels from '@/views/BMReceivedParcels.vue';
import FindParcels from '@/views/FindParcels.vue';
import RevenueReport from '@/views/RevenueReport.vue';
import MessageReport from '@/views/MessageReport.vue';
import Branches from '@/views/Branches.vue';
import Staffs from '@/views/Staffs.vue';
import Customers from '@/views/Customers.vue';
import Profile from '@/views/Profile.vue';
import ServiceTeam from '@/views/ServiceTeam.vue';
import ServiceReport from '@/views/ServiceReport.vue';
import ServiceIndividual from '@/views/ServiceIndividual.vue';
import MyIncommings from '@/views/MyIncommings.vue';
import SalesRecords from '@/views/SalesRecords.vue';
import SalesBranches from '@/views/SalesBranches.vue';

/*import Sales from '../views/Sales.vue';

import Messages from '@/views/Messages.vue';
import Cancelation from '@/views/Cancelation.vue';
import EditProduct from '@/views/EditProduct.vue';
import Staffs from '@/views/Staffs.vue';
import Profile from '@/views/profile.vue';*/


var user_cry = localStorage.getItem("user")  || "";
var user = CryptoJS.AES.decrypt(user_cry, 'user').toString(CryptoJS.enc.Utf8) || null
user = JSON.parse(user)


//only operators and adminsa
function authAdmins(){
  if(user){
    //user = JSON.parse(user)
    if(user.role > 1 && user.role < 4 ){

      return true
    }else{

     return {name:'Dashbord'}
    }
  }else{
    return {name:'Dashbord'}
  }
}

function authAll(){
  if(user){
    
    if(user.role < 5 ){
      return true
    }else{
      
        return {name:'Dashbord'}
    }
  }else{
    return {name:'Dashbord'}
  }
}

function authService(){
  if(user){
    
    if(user.role == 4 ){
      return true
    }else{
      
        return {name:'Dashbord'}
    }
  }else{
    return {name:'Dashbord'}
  }
}

function authSupper(){
  if(user){
    
    if(user.role == 3){
      return true
    }else{
      
    return {name:'Dashbord'}
    }
  }else{
    return {name:'Dashbord'}
  }
}

function authManager(){
  if(user){
    
    if(user.role == 2){
      return true
    }else{
      
       return {name:'Dashbord'}
    }
  }else{
    return {name:'Dashbord'}
  }
}


const routes = [
  {
    path: "/:pathMatch(.*)*",
    name: "Dashbord",
    component: Dashbord,
  },
  {
    path: '/',
    beforeEnter:authAll,
    name: 'Dashbord',
    component: Dashbord
  },
 {
    path: '/add-package',
    beforeEnter:authAll,
    name: 'add_package',
    component: AddParcel
  },
   {
    path: '/incomming-parcels',
    beforeEnter:authAll,
    name: 'incomming_parcels',
    component: IncomingParcels
  },
   {
    path: '/outgoing-parcels',
    beforeEnter:authAll,
    name: 'outgoing_parcels',
    component: OutgoingParcel
  },
   {
    path: '/transit-reports',
    beforeEnter:authSupper,
    name: 'transit-reports',
    component: TransitParcels
  },
  {
    path: '/received-reports',
    beforeEnter:authSupper,
    name: 'received-reports',
    component: ReceivedParcel
  },
    {
    path: '/bm-received-reports',
    beforeEnter:authManager,
    name: 'bm-received-reports',
    component: BMReceivedParcels
  },
   {
    path: '/removed-packages',
    beforeEnter:authAdmins,
    name: 'removed-packages',
    component: DeletedParcels
  },
  {
    path: '/search-page',
    beforeEnter:authAll,
    name: 'search-page',
    component: FindParcels
  },
    {
    path: '/revenue-reports',
    beforeEnter:authSupper,
    name: 'revenue-reports',
    component: RevenueReport
  },
  {
    path: '/message-report',
    beforeEnter:authAdmins,
    name: 'message-report',
    component: MessageReport
  },
    {
    path: '/branches',
    beforeEnter:authAll,
    name: 'branches',
    component: Branches
  },
  {
    path: '/staffs',
    beforeEnter:authAll,
    name: 'staffs',
    component: Staffs
  },
    {
    path: '/customers',
    beforeEnter:authAdmins,
    name: 'customers',
    component: Customers
  },
  {
    path: '/profile',
    beforeEnter:authAll,
    name: 'profile',
    component: Profile
  },
   {
    path: '/service-team',
    beforeEnter:authAdmins,
    name: 'service-team',
    component: ServiceTeam
  },
    {
    path: '/service-report',
    beforeEnter:authAdmins,
    name: 'service-report',
    component: ServiceReport
  },
  {
    path: '/my-service-report',
    beforeEnter:authService,
    name: 'my-service-report',
    component: ServiceReport
  },
   {
    path: '/service-team-report',
    beforeEnter:authService,
    name: 'service-team-report',
    component: ServiceTeam
  },
    {
    path: '/my-incomming-parcels',
    beforeEnter:authService,
    name: 'my-incomming-parcels',
    component: MyIncommings
  },
 
  {
    path: '/service-individual/:id',
    beforeEnter:authAdmins,
    name: 'service-individual',
    component: ServiceIndividual
  },
  {
    path: '/branches-sales',
    beforeEnter:authAdmins,
    name: 'branches-sales',
    component: SalesBranches
  },
  {
    path: '/sales-records',
    beforeEnter:authAdmins,
    name: 'sales-records',
    component: SalesRecords
  }
 
 
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
